<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("menu.coupon") }}
                    </h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <div class="row">

                            <div class="col-md-2 col-xs-12">
                                <base-input
								:label="keywordType"
                                    v-model="orderId"
                                    placeholder="หมายเลขสั่งซื้อ"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>

                            <div class="col-md-2 col-xs-12">
                                <base-input
								:label="keywordType"
                                    v-model="runningNumber"
                                    placeholder="หมายเลขคูปอง"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>


                            <div class="col-auto">
                                <base-button size="md" @click="handleSearch()">
                                    <i class="fas fa-spinner fa-spin " v-if="isLoading"></i>
                                    {{ $t("search") }}</base-button>
                                <base-button size="md" :loading="isLoading" @click="handleExport()" > Export</base-button>
                                <base-button size="md" :loading="isLoading" @click="handleAdvance()"> Advance</base-button>
                                <base-button size="md" type="danger" @click="showClearOrderModal = true" v-if="isAdmin">Clear Order</base-button>
                                <base-button size="md" type="success" @click="showSetOrderModal = true" v-if="isAdmin">Set Order</base-button>
                                <base-button size="md" type="info" @click="handleViewLogs()" v-if="isAdmin">View Logs</base-button>
                                <base-button size="md" type="primary" @click="showRegisterMemberModal = true" v-if="isWriteCouponMember">Register Member</base-button>
                             </div>
                        </div>

                        <div class="row">
                            <div class="col mt-2">
                              Coupon ID : {{  head.id }}  -  {{  head.name }}
                            </div>
                        </div>


                    </template>
                    <!-- end header -->

                    <div>
                        <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light">
                            <!-- order_number -->
                            <el-table-column align="left" :label="$t('number')" min-width="80px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.coupon_number }} </span>

                                </div>
                            </el-table-column>

                            <!-- created_at -->
                            <el-table-column align="left" :label="$t('order_id')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.bo_order_id }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('tracking')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.tracking_number }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('customer')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.fname }}  {{  row.lname }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('phone')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.phone }} </span>
                                </div>
                            </el-table-column>

                            <!-- <el-table-column align="left" :label="$t('date')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.updated_at }} </span>
                                </div>
                            </el-table-column> -->





                            <el-table-column align="right" :label="$t('actions')" min-width="180px">
                                <div slot-scope="{ $index, row }" class="d-flex">

                                    <base-button @click.native="
                                        handleDetail(row)
                                        " class="edit" type="warning" size="sm" icon>
                                        <i class="text-dtac-bt fa fa-list"></i>
                                    </base-button>

                                    <base-button @click.native="handleEditMember(row)" class="edit" type="info" size="sm" icon v-if="isWriteCouponMember && row.member_id">
                                        <i class="text-dtac-bt fa fa-user-edit"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0">
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <!-- Clear Order Modal -->
        <modal :show.sync="showClearOrderModal" modal-classes="modal-secondary">
            <h5 slot="header" class="modal-title">Clear Coupon Order</h5>
            <div class="row">
                <div class="col-md-6">
                    <base-input label="Order ID" v-model="clearOrderForm.order_id" placeholder="หมายเลขสั่งซื้อ"></base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="หรือ Tracking Number" v-model="clearOrderForm.tracking_number" placeholder="หมายเลขพัสดุ"></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <base-input label="เหตุผล">
                        <el-select v-model="clearOrderForm.reason" placeholder="เลือกเหตุผล" filterable>
                            <el-option v-for="reason in reasonOptions" :key="reason" :label="reason" :value="reason"></el-option>
                        </el-select>
                    </base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <base-input label="หมายเหตุ">
                        <textarea class="form-control" v-model="clearOrderForm.note" rows="3" placeholder="หมายเหตุเพิ่มเติม (ถ้ามี)"></textarea>
                    </base-input>
                </div>
            </div>
            <template slot="footer">
                <base-button type="danger" @click="confirmClearOrder()" :loading="isProcessing">
                    ยืนยัน Clear Order
                </base-button>
                <base-button type="link" @click="showClearOrderModal = false">ปิด</base-button>
            </template>
        </modal>

        <!-- Set Order Modal -->
        <modal :show.sync="showSetOrderModal" modal-classes="modal-secondary">
            <h5 slot="header" class="modal-title">Set Coupon Order</h5>
            <div class="row">
                <div class="col-md-12">
                    <base-input label="Coupon Running Numbers" v-model="setOrderForm.running_numbers" placeholder="เช่น 100001, 100002 หรือ 100001-100003"></base-input>
                    <small class="text-muted">ใส่หมายเลขคูปองคั่นด้วย comma หรือใช้ range เช่น 100001-100003</small>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-6">
                    <base-input label="Order ID" v-model="setOrderForm.order_id" placeholder="หมายเลขสั่งซื้อ"></base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="หรือ Tracking Number" v-model="setOrderForm.tracking_number" placeholder="หมายเลขพัสดุ"></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <base-input label="เหตุผล">
                        <el-select v-model="setOrderForm.reason" placeholder="เลือกเหตุผล" filterable>
                            <el-option v-for="reason in reasonOptions" :key="reason" :label="reason" :value="reason"></el-option>
                        </el-select>
                    </base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <base-input label="หมายเหตุ">
                        <textarea class="form-control" v-model="setOrderForm.note" rows="3" placeholder="หมายเหตุเพิ่มเติม (ถ้ามี)"></textarea>
                    </base-input>
                </div>
            </div>
            <template slot="footer">
                <base-button type="success" @click="confirmSetOrder()" :loading="isProcessing">
                    ยืนยัน Set Order
                </base-button>
                <base-button type="link" @click="showSetOrderModal = false">ปิด</base-button>
            </template>
        </modal>

        <!-- Register Member Modal -->
        <modal :show.sync="showRegisterMemberModal" modal-classes="modal-secondary">
            <h5 slot="header" class="modal-title">Register New Member</h5>
            <div class="row">
                <div class="col-md-12">
                    <base-input label="Coupon Number *" v-model="memberForm.coupon_number" placeholder="หมายเลขคูปอง (บังคับ) (CNYxxxxxx)"></base-input>
                    <small class="text-muted">กรอกหมายเลขคูปองที่ต้องการผูกกับสมาชิก (CNYxxxxxx)</small>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input label="First Name *" v-model="memberForm.fname" placeholder="ชื่อ"></base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="Last Name *" v-model="memberForm.lname" placeholder="นามสกุล"></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input label="Phone *" v-model="memberForm.phone" placeholder="เบอร์โทร"></base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="Email" v-model="memberForm.email" placeholder="อีเมล"></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <base-input label="LINE User ID *" v-model="memberForm.line_user_id" placeholder="LINE User ID (สามารถกรอกเองได้)"></base-input>
                    <small class="text-muted">กรอก LINE User ID ด้วยตนเอง เช่น U1234567890abcdef</small>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input label="Birthday (พ.ศ.)" v-model="memberForm.birthday" placeholder="2533-01-15"></base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="Sex">
                        <el-select v-model="memberForm.sex" placeholder="เพศ" filterable>
                            <el-option v-for="option in sexOptions" :key="option.id" :label="option.name" :value="option.id"></el-option>
                        </el-select>
                    </base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <base-input label="Address *" v-model="memberForm.address" placeholder="ที่อยู่ (บ้านเลขที่ ซอย ถนน)"></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input label="Subdistrict * (ตำบล/แขวง)" v-model="memberForm.subdistrict" placeholder="พิมพ์เพื่อค้นหา" @input="onAddressChange"></base-input>
                    <ul v-show="isAddressOpen" class="autocomplete-results">
                        <li v-for="(result, i) in filteredAddress" :key="i" @click="setAddressResult(result)" class="autocomplete-result">
                            <template v-if="result.ProvinceID == 10">
                                แขวง{{ result.District }} เขต{{ result.City }} จังหวัด{{ result.Province }} {{ result.Zipcode }}
                            </template>
                            <template v-else>
                                ต.{{ result.District }} อ.{{ result.City }} จ.{{ result.Province }} {{ result.Zipcode }}
                            </template>
                        </li>
                    </ul>
                </div>
                <div class="col-md-6">
                    <base-input label="District * (อำเภอ/เขต)" v-model="memberForm.district" placeholder="อำเภอ/เขต" disabled></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input label="Province * (จังหวัด)" v-model="memberForm.province" placeholder="จังหวัด" disabled></base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="Postcode *" v-model="memberForm.postcode" placeholder="รหัสไปรษณีย์" disabled></base-input>
                </div>
            </div>
            <template slot="footer">
                <base-button type="primary" @click="confirmRegisterMember()" :loading="isProcessing">
                    Register Member
                </base-button>
                <base-button type="link" @click="showRegisterMemberModal = false">ปิด</base-button>
            </template>
        </modal>

        <!-- Edit Member Modal -->
        <modal :show.sync="showEditMemberModal" modal-classes="modal-secondary">
            <h5 slot="header" class="modal-title">Edit Member</h5>
            <div class="row">
                <div class="col-md-6">
                    <base-input label="First Name" v-model="editMemberForm.fname" placeholder="ชื่อ"></base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="Last Name" v-model="editMemberForm.lname" placeholder="นามสกุล"></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input label="Phone" v-model="editMemberForm.phone" placeholder="เบอร์โทร"></base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="Email" v-model="editMemberForm.email" placeholder="อีเมล"></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <base-input label="LINE User ID" v-model="editMemberForm.line_user_id" :disabled="!isLineUserIdEditable"></base-input>
                    <small class="text-muted" v-if="!isLineUserIdEditable">LINE User ID ไม่สามารถแก้ไขได้</small>
                    <small class="text-muted" v-else>สามารถแก้ไข LINE User ID ได้เนื่องจากยังไม่มีข้อมูล</small>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input label="Birthday" v-model="editMemberForm.birthday" type="date"></base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="Sex">
                        <el-select v-model="editMemberForm.sex" placeholder="เพศ" filterable>
                            <el-option v-for="option in sexOptions" :key="option.id" :label="option.name" :value="option.id"></el-option>
                        </el-select>
                    </base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <base-input label="Address" v-model="editMemberForm.address" placeholder="ที่อยู่"></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <base-input label="Province" v-model="editMemberForm.province" placeholder="จังหวัด"></base-input>
                </div>
                <div class="col-md-4">
                    <base-input label="District" v-model="editMemberForm.district" placeholder="อำเภอ/เขต"></base-input>
                </div>
                <div class="col-md-4">
                    <base-input label="Subdistrict" v-model="editMemberForm.subdistrict" placeholder="ตำบล/แขวง"></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input label="Postcode" v-model="editMemberForm.postcode" placeholder="รหัสไปรษณีย์"></base-input>
                </div>
                <div class="col-md-6">
                    <base-input label="Status">
                        <el-select v-model="editMemberForm.status" placeholder="สถานะ" filterable>
                            <el-option v-for="option in statusOptions" :key="option.id" :label="option.name" :value="option.id"></el-option>
                        </el-select>
                    </base-input>
                </div>
            </div>
            <template slot="footer">
                <base-button type="primary" @click="confirmEditMember()" :loading="isProcessing">
                    Update Member
                </base-button>
                <base-button type="link" @click="showEditMemberModal = false">ปิด</base-button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination, Modal } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'
import FileInput from "@/components/Inputs/FileInput";
import { undistributeHeight } from '@fullcalendar/core';
import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        Modal,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Coupon/getDataDetail",
            isLoading: "Coupon/isLoading",

            isAdmin: "Auth/isAdmin",
            isOwner: "Auth/isOwner",
            isEmployee: "Auth/isEmployee",
            isAgent: "Auth/isAgent",
            // Coupon Member permissions
            isReadCouponMember: "Auth/isReadCouponMember",
            isWriteCouponMember: "Auth/isWriteCouponMember",
            isDeleteCouponMember: "Auth/isDeleteCouponMember",
            // Address
            FullAddr: "Order/getAddress",
        }),
        filteredAddress() {
            if (!this.memberForm.subdistrict || this.memberForm.subdistrict.length < 2) {
                return [];
            }
            let result = this.FullAddr.filter(item => {
                let search = false;
                let key = this.memberForm.subdistrict.split(" ");
                if (key.length == 1) {
                    search = item.District.includes(key[0]) || item.Zipcode == key[0];
                }
                if (key.length == 2) {
                    search = (item.District.includes(key[0]) || item.Zipcode == key[0]) && item.City.includes(key[1]);
                }
                if (key.length == 3) {
                    search = (item.District.includes(key[0]) || item.Zipcode == key[0]) && item.City.includes(key[1]) && item.Province.includes(key[2]);
                }
                return search;
            });
            return result.slice(0, 15);
        },
    },
    data() {
        return {
            propsToSearch: ["running_number", "code"],
            selectedRows: [],
            orderId: "",
            trackingNumber : "",
            runningNumber : "",
            headId : "",
            head: {},
            // Clear/Set Order modals
            showClearOrderModal: false,
            showSetOrderModal: false,
            isProcessing: false,
            clearOrderForm: {
                order_id: '',
                tracking_number: '',
                reason: '',
                note: ''
            },
            setOrderForm: {
                running_numbers: '',
                order_id: '',
                tracking_number: '',
                reason: '',
                note: ''
            },
            reasonOptions: [
                'ยกเลิกคูปองจากการยิงผิด',
                'สินค้าตีกลับ',
                'ลูกค้ายกเลิก',
                'ผูกคูปองเพิ่มเติม',
                'แก้ไขข้อมูล',
                'อื่นๆ'
            ],
            // Member modals
            showRegisterMemberModal: false,
            showEditMemberModal: false,
            editMemberId: 0,
            isLineUserIdEditable: false,
            isAddressOpen: false,
            memberForm: {
                enterprise_id: 1,
                coupon_number: '',
                fname: '',
                lname: '',
                line_user_id: '',
                phone: '',
                email: '',
                birthday: '2533-01-01',
                sex: 0,
                status: 0,
                address: '',
                province: '',
                district: '',
                subdistrict: '',
                postcode: '',
                province_id: 0,
                district_id: 0,
                subdistrict_id: 0
            },
            editMemberForm: {
                enterprise_id: 1,
                fname: '',
                lname: '',
                line_user_id: '',
                phone: '',
                email: '',
                birthday: '1990-01-01',
                sex: 0,
                status: 0,
                address: '',
                province: '',
                district: '',
                subdistrict: '',
                postcode: '',
                province_id: 0,
                district_id: 0,
                subdistrict_id: 0
            },
            sexOptions: [
                { id: 0, name: 'Not specified' },
                { id: 1, name: 'Unknown' },
                { id: 2, name: 'Male' },
                { id: 3, name: 'Female' }
            ],
            statusOptions: [
                { id: 0, name: 'Non-verified phone' },
                { id: 1, name: 'Normal (verified)' },
                { id: 2, name: 'Blocked' }
            ]
        };
    },
    async mounted() {

        this.clearDataDetail();
        this.headId = this.$route.params.id

        if (this.headId == "" ) {
            this.$router.push("/backoffice/coupon");
        }

        try {

            const resp = await this.getData({id: this.headId});
            this.head = resp.data.Datum
        }
        catch (error) {
            console.log(error);
            // this.$router.push("/backoffice/coupon");
        }

        // Load address data for autocomplete
        if (this.FullAddr.length == 0) {
            this.listFullAddr();
        }

        // Close address dropdown when clicking outside
        document.addEventListener("click", this.handleClickOutside);
    },
    destroyed() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        ...mapActions({
            listData: "Coupon/listDataDetail",
            getData: "Coupon/getData",
            listDataDetail: "Coupon/listDataDetail",
            clearDataDetail: "Coupon/clearDataDetail",
            clearCouponOrder: "Coupon/clearCouponOrder",
            setCouponOrder: "Coupon/setCouponOrder",
            // Member actions
            createMember: "Member/createData",
            updateMember: "Member/updateData",
            // Address
            listFullAddr: "Order/listAddressV2",
        }),
        handleSearch() {
            const params = {
                head_id: this.headId,
                order_id: this.orderId,
                tracking_number: this.trackingNumber,
                running_number: this.runningNumber,
            }
            this.listData(params);
        },
        handleAdvance(){
            this.$router.push("/backoffice/coupon/all/" + this.headId);
        },
        handleExport(){
            let i = 1
			let dataExport = this.tableData.map((v) => {
				return {
				NO: i++,
				CouponNumber: v.coupon_number,
				CouponCode: v.coupon_code,
				Address: v.address,
				SubDistrict: v.subdistrict,
				Distrcit: v.district,
				Province: v.province,
				PHone: v.phone,
				Firstname: v.fname,
				Lastname: v.lname,
				TrackingNumber: v.tracking_number,
				}

			})
			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,'export_coupon.xlsx')

        },
        handleDetail(row) {
            // swal show row.url

            swal.fire ({
                title: 'Coupon Detail',
                html: `
                    <div class="row text-left">
                        <div class="col-4">Coupon Number</div>
                        <div class="col-8">${row.coupon_number}</div>
                    </div>
                    <div class="row text-left">
                        <div class="col-4">Order ID</div>
                        <div class="col-8">${row.bo_order_id}</div>
                    </div>
                    <div class="row text-left">
                        <div class="col-4">Tracking Number</div>
                        <div class="col-8">${row.tracking_number}</div>
                    </div>
                    <div class="row text-left">
                        <div class="col-4">Customer</div>
                        <div class="col-8">${row.fname} ${row.lname}</div>
                    </div>
                    <div class="row text-left">
                        <div class="col-4">Phone</div>
                        <div class="col-8">${row.phone}</div>
                    </div>

                    <div class="row text-left">
                        <div class="col-4">URL</div>
                        <div class="col-8">${row.url}</div>
                    </div>
                `,
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
            })


        },



        handleCreate() {
            this.$router.push("/backoffice/po/create");
        },

        handleViewLogs() {
            this.$router.push("/backoffice/coupon/logs/" + this.headId);
        },

        async confirmClearOrder() {
            // Validate input
            if (!this.clearOrderForm.order_id && !this.clearOrderForm.tracking_number) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาระบุ Order ID หรือ Tracking Number',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            // Confirm before clear
            const result = await swal.fire({
                title: 'ยืนยันการ Clear Order',
                text: 'คุณต้องการยกเลิกคูปองจาก Order นี้ใช่หรือไม่?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก',
                confirmButtonClass: 'btn btn-danger',
                cancelButtonClass: 'btn btn-secondary'
            });

            if (!result.value) return;

            this.isProcessing = true;
            try {
                const params = {
                    head_id: parseInt(this.headId),
                    order_id: this.clearOrderForm.order_id ? parseInt(this.clearOrderForm.order_id) : 0,
                    tracking_number: this.clearOrderForm.tracking_number,
                    reason: this.clearOrderForm.reason,
                    note: this.clearOrderForm.note
                };

                const resp = await this.clearCouponOrder(params);
                const clearedCount = (resp.data.Datum && resp.data.Datum.cleared_count) || 0;

                swal.fire({
                    title: 'สำเร็จ',
                    text: resp.data.message || 'Clear ' + clearedCount + ' coupon(s) สำเร็จ',
                    icon: 'success',
                    confirmButtonClass: 'btn btn-success'
                });

                this.showClearOrderModal = false;
                this.resetClearOrderForm();
                this.handleSearch();
            } catch (error) {
                const errMsg = (error.response && error.response.data && (error.response.data.message || error.response.data.Cause)) || 'ไม่สามารถดำเนินการได้';
                swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: errMsg,
                    icon: 'error',
                    confirmButtonClass: 'btn btn-danger'
                });
            } finally {
                this.isProcessing = false;
            }
        },

        async confirmSetOrder() {
            // Validate input
            if (!this.setOrderForm.running_numbers) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาระบุ Coupon Running Numbers',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            if (!this.setOrderForm.order_id && !this.setOrderForm.tracking_number) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาระบุ Order ID หรือ Tracking Number',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            // Parse running numbers (support comma-separated and range)
            const runningNumbers = this.parseRunningNumbers(this.setOrderForm.running_numbers);
            if (runningNumbers.length === 0) {
                swal.fire({
                    title: 'รูปแบบไม่ถูกต้อง',
                    text: 'กรุณาระบุ Running Numbers ในรูปแบบที่ถูกต้อง เช่น 100001, 100002 หรือ 100001-100003',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            // Confirm before set
            const result = await swal.fire({
                title: 'ยืนยันการ Set Order',
                text: `คุณต้องการผูก ${runningNumbers.length} coupon(s) กับ Order นี้ใช่หรือไม่?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก',
                confirmButtonClass: 'btn btn-success',
                cancelButtonClass: 'btn btn-secondary'
            });

            if (!result.value) return;

            this.isProcessing = true;
            try {
                const params = {
                    head_id: parseInt(this.headId),
                    coupon_running_numbers: runningNumbers,
                    order_id: this.setOrderForm.order_id ? parseInt(this.setOrderForm.order_id) : 0,
                    tracking_number: this.setOrderForm.tracking_number,
                    reason: this.setOrderForm.reason,
                    note: this.setOrderForm.note
                };

                const resp = await this.setCouponOrder(params);

                const setCount = (resp.data.Datum && resp.data.Datum.set_count) || 0;
                const skippedCount = (resp.data.Datum && resp.data.Datum.skipped_count) || 0;
                var message = 'Set ' + setCount + ' coupon(s) สำเร็จ';
                if (skippedCount > 0) {
                    message += ', ข้าม ' + skippedCount + ' coupon(s) ที่ผูกอยู่แล้ว';
                }

                swal.fire({
                    title: 'สำเร็จ',
                    text: message,
                    icon: 'success',
                    confirmButtonClass: 'btn btn-success'
                });

                this.showSetOrderModal = false;
                this.resetSetOrderForm();
                this.handleSearch();
            } catch (error) {
                const errMsg = (error.response && error.response.data && (error.response.data.message || error.response.data.Cause)) || 'ไม่สามารถดำเนินการได้';
                swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: errMsg,
                    icon: 'error',
                    confirmButtonClass: 'btn btn-danger'
                });
            } finally {
                this.isProcessing = false;
            }
        },

        parseRunningNumbers(input) {
            const numbers = [];
            const parts = input.split(',').map(p => p.trim()).filter(p => p);

            for (const part of parts) {
                if (part.includes('-')) {
                    // Range format: 100001-100003
                    const [start, end] = part.split('-').map(n => parseInt(n.trim()));
                    if (!isNaN(start) && !isNaN(end) && start <= end) {
                        for (let i = start; i <= end; i++) {
                            numbers.push(i);
                        }
                    }
                } else {
                    // Single number
                    const num = parseInt(part);
                    if (!isNaN(num)) {
                        numbers.push(num);
                    }
                }
            }

            return numbers;
        },

        resetClearOrderForm() {
            this.clearOrderForm = {
                order_id: '',
                tracking_number: '',
                reason: '',
                note: ''
            };
        },

        resetSetOrderForm() {
            this.setOrderForm = {
                running_numbers: '',
                order_id: '',
                tracking_number: '',
                reason: '',
                note: ''
            };
        },

        // Member methods
        resetMemberForm() {
            this.memberForm = {
                enterprise_id: 1,
                coupon_number: '',
                fname: '',
                lname: '',
                line_user_id: '',
                phone: '',
                email: '',
                birthday: '2533-01-01',
                sex: 0,
                status: 0,
                address: '',
                province: '',
                district: '',
                subdistrict: '',
                postcode: '',
                province_id: 0,
                district_id: 0,
                subdistrict_id: 0
            };
            this.isAddressOpen = false;
        },

        // Address autocomplete methods
        onAddressChange() {
            this.isAddressOpen = true;
            // Clear other address fields when typing
            this.memberForm.district = '';
            this.memberForm.province = '';
            this.memberForm.postcode = '';
            this.memberForm.province_id = 0;
            this.memberForm.district_id = 0;
            this.memberForm.subdistrict_id = 0;
        },

        setAddressResult(result) {
            this.memberForm.subdistrict = result.District;
            this.memberForm.district = result.City;
            this.memberForm.province = result.Province;
            this.memberForm.postcode = result.Zipcode;
            this.memberForm.province_id = result.ProvinceID;
            this.memberForm.district_id = result.CityID;
            this.memberForm.subdistrict_id = result.DistrictID;
            this.isAddressOpen = false;
        },

        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.isAddressOpen = false;
            }
        },

        resetEditMemberForm() {
            this.editMemberForm = {
                enterprise_id: 1,
                fname: '',
                lname: '',
                line_user_id: '',
                phone: '',
                email: '',
                birthday: '1990-01-01',
                sex: 0,
                status: 0,
                address: '',
                province: '',
                district: '',
                subdistrict: '',
                postcode: '',
                province_id: 0,
                district_id: 0,
                subdistrict_id: 0
            };
            this.editMemberId = 0;
            this.isLineUserIdEditable = false;
        },

        async confirmRegisterMember() {
            // Validate required fields
            if (!this.memberForm.coupon_number) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาระบุหมายเลขคูปอง',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            if (!this.memberForm.fname || !this.memberForm.lname) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาระบุชื่อและนามสกุล',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            if (!this.memberForm.phone) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาระบุเบอร์โทรศัพท์',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            if (!this.memberForm.line_user_id) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาระบุ LINE User ID',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            // Validate email format if not empty
            if (this.memberForm.email && this.memberForm.email.trim() !== '') {
                // Supports formats: abc@abc.com, abc@abc.co.th, abc@abc.xx.yy
                const emailRegex = /^[^\s@]+@[^\s@]+(\.[^\s@]+)+$/;
                if (!emailRegex.test(this.memberForm.email)) {
                    swal.fire({
                        title: 'รูปแบบอีเมลไม่ถูกต้อง',
                        text: 'กรุณาระบุอีเมลในรูปแบบที่ถูกต้อง เช่น example@email.com หรือ example@email.co.th',
                        icon: 'warning',
                        confirmButtonClass: 'btn btn-warning'
                    });
                    return;
                }
            }

            if (!this.memberForm.address) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาระบุที่อยู่',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            if (!this.memberForm.subdistrict || !this.memberForm.district || !this.memberForm.province || !this.memberForm.postcode) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาเลือกตำบล/แขวง จากรายการ',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            // Validate birthday format and value
            if (this.memberForm.birthday) {
                const birthdayRegex = /^\d{4}-\d{2}-\d{2}$/;
                if (!birthdayRegex.test(this.memberForm.birthday)) {
                    swal.fire({
                        title: 'รูปแบบวันเกิดไม่ถูกต้อง',
                        text: 'กรุณาระบุวันเกิดในรูปแบบ พ.ศ.-เดือน-วัน เช่น 2533-01-15',
                        icon: 'warning',
                        confirmButtonClass: 'btn btn-warning'
                    });
                    return;
                }

                const parts = this.memberForm.birthday.split('-');
                const year = parseInt(parts[0]);
                const month = parseInt(parts[1]);
                const day = parseInt(parts[2]);

                // Validate Buddhist year (should be between 2443-2600 roughly, i.e., 1900-2057 CE)
                if (year < 2443 || year > 2600) {
                    swal.fire({
                        title: 'ปี พ.ศ. ไม่ถูกต้อง',
                        text: 'กรุณาระบุปี พ.ศ. ระหว่าง 2443-2600',
                        icon: 'warning',
                        confirmButtonClass: 'btn btn-warning'
                    });
                    return;
                }

                // Validate month
                if (month < 1 || month > 12) {
                    swal.fire({
                        title: 'เดือนไม่ถูกต้อง',
                        text: 'กรุณาระบุเดือน 01-12',
                        icon: 'warning',
                        confirmButtonClass: 'btn btn-warning'
                    });
                    return;
                }

                // Validate day
                if (day < 1 || day > 31) {
                    swal.fire({
                        title: 'วันที่ไม่ถูกต้อง',
                        text: 'กรุณาระบุวันที่ 01-31',
                        icon: 'warning',
                        confirmButtonClass: 'btn btn-warning'
                    });
                    return;
                }

                // Validate the date is not in the future
                const gregorianYear = year - 543;
                const inputDate = new Date(gregorianYear, month - 1, day);
                const today = new Date();
                if (inputDate > today) {
                    swal.fire({
                        title: 'วันเกิดไม่ถูกต้อง',
                        text: 'วันเกิดต้องไม่เป็นวันในอนาคต',
                        icon: 'warning',
                        confirmButtonClass: 'btn btn-warning'
                    });
                    return;
                }
            }

            this.isProcessing = true;
            try {
                // Convert birthday from Buddhist year (พ.ศ.) to Gregorian year (ค.ศ.) for API
                // User inputs: 2533-01-15 (พ.ศ.) -> API receives: 1990-01-15 (ค.ศ.)
                let gregorianBirthday = this.memberForm.birthday;
                if (this.memberForm.birthday) {
                    const parts = this.memberForm.birthday.split('-');
                    if (parts.length === 3) {
                        const gregorianYear = parseInt(parts[0]) - 543;
                        gregorianBirthday = `${gregorianYear}-${parts[1]}-${parts[2]}`;
                    }
                }

                const payload = {
                    ...this.memberForm,
                    coupon_head_id: parseInt(this.headId),
                    coupon_number: String(this.memberForm.coupon_number),
                    birthday: gregorianBirthday
                };
                console.log('Register Member Payload:', JSON.stringify(payload, null, 2));
                await this.createMember(payload);

                swal.fire({
                    title: 'สำเร็จ',
                    text: 'สร้าง Member สำเร็จ',
                    icon: 'success',
                    confirmButtonClass: 'btn btn-success'
                });

                this.showRegisterMemberModal = false;
                this.resetMemberForm();
                this.handleSearch(); // Refresh data
            } catch (error) {
                const errMsg = (error.response && error.response.data && (error.response.data.message || error.response.data.Cause)) || 'ไม่สามารถสร้าง Member ได้';
                swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: errMsg,
                    icon: 'error',
                    confirmButtonClass: 'btn btn-danger'
                });
            } finally {
                this.isProcessing = false;
            }
        },

        handleEditMember(row) {
            // Populate edit form with row data (from coupon detail)
            this.editMemberId = row.member_id || 0;
            this.editMemberForm.fname = row.fname || '';
            this.editMemberForm.lname = row.lname || '';
            this.editMemberForm.phone = row.phone || '';
            this.editMemberForm.email = row.email || '';
            this.editMemberForm.line_user_id = row.line_user_id || '';
            this.editMemberForm.address = row.address || '';
            this.editMemberForm.province = row.province || '';
            this.editMemberForm.district = row.district || '';
            this.editMemberForm.subdistrict = row.subdistrict || '';
            this.editMemberForm.postcode = row.postcode || '';
            this.editMemberForm.sex = row.sex || 0;
            this.editMemberForm.status = row.status || 0;
            this.editMemberForm.birthday = row.birthday ? row.birthday.split('T')[0] : '1990-01-01';

            // Allow editing line_user_id if it's empty or "-"
            this.isLineUserIdEditable = !row.line_user_id || row.line_user_id === '' || row.line_user_id === '-';

            this.showEditMemberModal = true;
        },

        async confirmEditMember() {
            // Validate required fields
            if (!this.editMemberForm.fname || !this.editMemberForm.lname) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาระบุชื่อและนามสกุล',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            if (!this.editMemberForm.phone) {
                swal.fire({
                    title: 'กรุณาระบุข้อมูล',
                    text: 'กรุณาระบุเบอร์โทรศัพท์',
                    icon: 'warning',
                    confirmButtonClass: 'btn btn-warning'
                });
                return;
            }

            if (!this.editMemberId) {
                swal.fire({
                    title: 'ไม่พบข้อมูล Member',
                    text: 'ไม่พบ Member ID กรุณาลองใหม่อีกครั้ง',
                    icon: 'error',
                    confirmButtonClass: 'btn btn-danger'
                });
                return;
            }

            this.isProcessing = true;
            try {
                await this.updateMember({
                    id: this.editMemberId,
                    payload: this.editMemberForm
                });

                swal.fire({
                    title: 'สำเร็จ',
                    text: 'อัพเดท Member สำเร็จ',
                    icon: 'success',
                    confirmButtonClass: 'btn btn-success'
                });

                this.showEditMemberModal = false;
                this.resetEditMemberForm();
                this.handleSearch(); // Refresh data
            } catch (error) {
                const errMsg = (error.response && error.response.data && (error.response.data.message || error.response.data.Cause)) || 'ไม่สามารถอัพเดท Member ได้';
                swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: errMsg,
                    icon: 'error',
                    confirmButtonClass: 'btn btn-danger'
                });
            } finally {
                this.isProcessing = false;
            }
        },

    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    max-height: 200px;
    overflow: auto;
    position: absolute;
    background: white;
    width: 100%;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
}

.autocomplete-result:hover {
    background-color: #5e72e4;
    color: white;
}

.autocomplete-result:last-child {
    border-bottom: none;
}
</style>
